// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/underline.js';

import { paths } from '../generated/underline';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('underline', Original, paths);
